import React from 'react'

import { IconNotebook, Icon, palette } from '@centivo/react-components'
import styled, { css } from 'styled-components'
import { formatPhone } from 'src/refactor/helpers/format'
import { useSliceTemplate } from 'src/context/global'

type TIconTextComponentAttributes = {
  marginBottom?: string
  marginTop?: string
  gridColumn?: string
}

const RliIconTextContainer = styled.div<TIconTextComponentAttributes>`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: ${({ marginTop = '0.8rem' }) => marginTop};
  ${props =>
    props.marginBottom ? `margin-bottom: ${props.marginBottom};` : ''}
  grid-column: ${props => props.gridColumn ?? '1 / span 2'};

  span {
    font-size: 1rem;
    line-height: 1.5;
    margin-left: 0.5rem;
    color: ${palette.brand.darkGray};

    ${({ theme }) => {
      switch (theme.template) {
        case 'template-4':
          return css`
            font-weight: 400;
          `
        default:
          return css`
            font-weight: 500;
          `
      }
    }}
  }
`

const IconTextComponent: React.FC<
  {
    icon: IconNotebook
    text: string
    color?: string
  } & TIconTextComponentAttributes
> = ({ icon, text, color, ...props }) => (
  <RliIconTextContainer {...props}>
    <Icon
      icon={icon}
      color={color || palette.brand.teal}
      size="1.5rem"
      aria-hidden
    />
    <span>{text}</span>
  </RliIconTextContainer>
)

export const PhoneNumber: React.FC<
  {
    number: string
  } & TIconTextComponentAttributes
> = ({ number, ...props }) => {
  const isSliceTemplate = useSliceTemplate()
  const icon = isSliceTemplate ? 'slice-phone' : 'phone'

  if (!number) return null
  return (
    <IconTextComponent
      icon={icon}
      text={formatPhone(number)}
      color="#44190a"
      {...props}
    />
  ) as React.ReactElement
}

export const VirtualCare: React.FC<{ icon: 'video' | 'slice-video' }> = ({
  icon = 'video',
}) => <IconTextComponent icon={icon} text="Virtual care available" />

export const FaxNumber: React.FC<
  { number: string } & TIconTextComponentAttributes
> = ({ number, ...props }) => (
  <IconTextComponent icon="fax" text={number} {...props} />
)
